import { app } from '../actions';

const initialState = {
	dialog: {
		isOpen: false,
		component: null,
	},
};

const appReducer = (state = initialState, action) => {
	switch (action.type) {
		case app.APP_DIALOG_TOGGLE:
			return {
				...state,
				dialog: {
					...state.dialog,
					isOpen: !state.dialog.isOpen,
					component: action.component,
				},
			};
		case app.APP_DIALOG_OPEN:
		case app.APP_DIALOG_CLOSE:
			return {
				...state,
				dialog: {
					...state.dialog,
					isOpen: action.type === app.APP_DIALOG_OPEN,
					component: action.component || state.component, // to avoid blinking
				},
			};
		default:
			return state;
	}
};

export default appReducer;
